import { Injectable } from '@angular/core';
import { Features as FeatureConfig } from 'feature-flag-config/generated/features';
import { FeatureFlagConfigProviderService } from './feature-flag-config-provider.service';
import { FeatureNames } from 'feature-flag-config/generated/feature-names';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {

  /**
   *
   */
  constructor(private _configProvider?: FeatureFlagConfigProviderService) {
  }

  /**
   * Check if a feature is off
   */
  featureOff(featureName: FeatureNames) {
    // Read the value from the config
    const config = this._configProvider?.getFeatureConfig() || FeatureConfig;
    if (config.hasOwnProperty(featureName)) {
      return !config[featureName];
    }
    return true; // if feature not found, default to turned off
  }

  /**
   * Check if a feature is on
   */
  featureOn(featureName: FeatureNames) {
    return !this.featureOff(featureName);
  }
}
